// import React from "react";
// import { ArrowRight } from "lucide-react";
// import { useEffect } from "react";
// import img2 from "../../Assets/Images/CD2.png";
// import img1 from "../../Assets/Images/CD1.png";

// export default function CovenantsShowcase() {
//   useEffect(() => {
//     // Simulating AOS initialization
//     console.log("AOS initialized");
//   }, []);

//   const properties = [
//     {
//       id: 1,
//       title: "MI CASA",
//       image: img1,
//       status: "available",
//     },
//     {
//       id: 2,
//       title: "LA CASA",
//       image: img2,
//       status: "available",
//     },
//     {
//       id: 3,
//       title: "COMING SOON",
//       image:
//         "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
//       status: "coming-soon",
//     },
//   ];

//   return (
//     <div className="pt-8 w-full mx-auto px-4">
//       {/* Header Section */}
//       <div className="flex justify-between items-center mb-6 sm:mb-8">
//         <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold">
//           <span className="text-orange-500">Covenants</span>{" "}
//           <span className="text-gray-900">Showcasing Trust</span>
//         </h2>
//         <button className="text-orange-500 hover:text-orange-600 font-medium text-sm sm:text-base transition-colors">
//           View All
//         </button>
//       </div>

//       {/* Cards Grid */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
//         {properties.map((property) => (
//           <div
//             key={property.id}
//             className="relative group cursor-pointer overflow-hidden rounded-xl aspect-[4/3]"
//           >
//             {/* Background Image */}
//             <img
//               src={property.image}
//               alt={property.title}
//               className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
//             />

//             {/* Dark Overlay that appears on hover */}
//             <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-300"></div>

//             {/* Content Overlay - Hidden by default, visible on hover */}
//             <div className="absolute inset-0 flex items-end p-6 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-4 group-hover:translate-y-0">
//               <div className="flex items-center justify-between w-full">
//                 <h3 className="text-white font-bold text-lg sm:text-xl tracking-wider">
//                   {property.title}
//                 </h3>
//                 <div className="flex items-center space-x-2">
//                   {property.badge && (
//                     <div className="w-8 h-8 bg-orange-500 rounded-full flex items-center justify-center">
//                       <span className="text-white font-bold text-sm">
//                         {property.badge}
//                       </span>
//                     </div>
//                   )}
//                   <div className="w-10 h-10 bg-white bg-opacity-20 backdrop-blur-sm rounded-full flex items-center justify-center">
//                     <ArrowRight className="w-5 h-5 text-white" />
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Coming Soon Overlay for the third card */}
//             {property.status === "coming-soon" && (
//               <div className="absolute inset-0 bg-gray-200 bg-opacity-90 flex items-center justify-center">
//                 <h3 className="text-gray-800 font-bold text-2xl tracking-wider">
//                   COMING SOON
//                 </h3>
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function CovenantsShowcase() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Authentication check function - same as ProjectsList
  const isUserAuthenticated = () => {
    const userData = localStorage.getItem("userData");

    if (!userData) {
      return false;
    }

    try {
      const parsedUserData = JSON.parse(userData);

      const requiredFields = ["id", "email", "name", "phoneNumber"];
      const hasAllFields = requiredFields.every(
        (field) => parsedUserData[field] && parsedUserData[field].trim() !== ""
      );

      return hasAllFields;
    } catch (error) {
      console.error("Error parsing userData from localStorage:", error);
      return false;
    }
  };

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/projects/all-projects`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch projects");
        }
        const data = await response.json();
        setProjects(data.slice(0, 3));
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  // Handle navigation to project details with authentication check
  const handleProjectClick = (projectId) => {
    const isAuthenticated = isUserAuthenticated();

    if (isAuthenticated) {
      navigate(`/projects/project-details/${projectId}`);
    } else {
      navigate("/user-login");
    }
  };

  // Prepare display cards based on available projects
  const getDisplayCards = () => {
    const cards = [];

    // Add actual projects (up to 3)
    projects.forEach((project, index) => {
      cards.push({
        id: project._id,
        title: project.projectName,
        image: project.images[0], // Use first image
        status: "available",
        type: "project",
      });
    });

    // If less than 3 projects, add "Coming Soon" cards
    while (cards.length < 3) {
      cards.push({
        id: `coming-soon-${cards.length}`,
        title: "COMING SOON",
        image:
          "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
        status: "coming-soon",
        type: "coming-soon",
      });
    }

    return cards;
  };

  if (loading) {
    return (
      <div className="pt-8 w-full mx-auto px-4">
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500"></div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pt-8 w-full mx-auto px-4">
        <div className="flex justify-center items-center h-64">
          <div className="text-red-500 text-center">
            <p className="text-lg font-semibold">Error loading projects</p>
            <p className="text-sm">{error}</p>
          </div>
        </div>
      </div>
    );
  }

  const displayCards = getDisplayCards();

  return (
    <div className="pt-8 w-full mx-auto px-4 mb-4">
      {/* Header Section */}
      <div className="flex justify-between items-center mb-6 sm:mb-8">
        <h2 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold">
          <span className="text-[#FF5E14] font-semibold">Covenants</span>{" "}
          <span className="text-gray-900 font-semibold">Showcasing Trust</span>
        </h2>
        <button
          className="hidden lg:block text-[#FF5E14] hover:text-orange-600 font-medium text-sm sm:text-base transition-colors"
          onClick={() => {
            navigate("/projects");
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          View All
        </button>
      </div>

      {/* Cards Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
        {displayCards.map((card) => (
          <div
            key={card.id}
            className="relative group cursor-pointer overflow-hidden rounded-xl aspect-[4/3]"
            onClick={() =>
              card.type === "project" && handleProjectClick(card.id)
            }
          >
            {/* Background Image */}
            <img
              src={card.image}
              alt={card.title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              onError={(e) => {
                e.target.src =
                  "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80";
              }}
            />

            {/* Dark Overlay that appears on hover */}
            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition-all duration-300"></div>

            {/* Content Overlay - Hidden by default, visible on hover */}
            {card.type === "project" && (
              <div className="absolute inset-0 flex items-end p-6 opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-y-4 group-hover:translate-y-0">
                <div className="flex items-center justify-between w-full">
                  <h3 className="text-white font-bold text-lg sm:text-xl tracking-wider">
                    {card.title}
                  </h3>
                  <div className="flex items-center space-x-2">
                    <div
                      className="w-10 h-10 bg-white bg-opacity-20 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-opacity-30 transition-all duration-200"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleProjectClick(card.id);
                      }}
                    >
                      <ArrowRight className="w-5 h-5 text-white" />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Coming Soon Overlay */}
            {card.status === "coming-soon" && (
              <div className="absolute inset-0 bg-gray-200 bg-opacity-90 flex items-center justify-center">
                <h3 className="text-gray-800 font-bold text-2xl tracking-wider">
                  COMING SOON
                </h3>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
